// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"130":"basket","205":"favorites","901":"archives"}[chunkId] || chunkId) + "." + {"29":"ab00fa00","30":"1525ca91","130":"fedc34a4","205":"d8b1bb34","496":"4cecf109","901":"a1cc4ad3"}[chunkId] + ".chunk.js";
};